<template>
  <section class="settings-section">
    <div class="container-fluid px-0 px-lg-2">
      <div class="row g-0">
        <!-- Sidebar -->
        <aside
          class="sidebar col-lg-2 px-lg-0"
          :class="{ 'mobile-active': isMobileMenuOpen }"
        >
          <div class="sidebar-wrapper px-2">
            <!-- Close button for mobile -->
            <button
              class="close-mobile-menu d-lg-none"
              @click="toggleMobileMenu"
              aria-label="Cerrar menú"
            >
              <i class="fas fa-times"></i>
            </button>

            <!-- Navigation Menu -->
            <nav class="settings-nav">
              <!-- Admin Menu -->              
               <div class="d-flex justify-content-start mb-4">
                <router-link to="/" class="d-block" style="max-width: 100%;">
                  <img
                    src="@/assets/images/logo.png"
                    alt="Logo"
                    class="img-fluid mb-1"
                    style="max-width: 180px; width: 100%;"
                  />
                </router-link>
              </div>
              <div v-if="isAdmin" class="nav-section">
                <h6 class="nav-title">ADMINISTRACIÓN</h6>
                <router-link
                  to="/configuracion"
                  class="nav-link"
                  :class="{
                    active: $route.path === '/configuracion'
                  }"
                  @click="isMobileMenuOpen && toggleMobileMenu()"
                >
                  <i class="fas fa-home"></i>
                  <span>General</span>
                </router-link>

                <router-link
                  to="/configuracion/banners-inicio"
                  class="nav-link"
                  :class="{
                    active: $route.path === '/configuracion/banners-inicio',
                  }"
                  @click="isMobileMenuOpen && toggleMobileMenu()"
                >
                  <i class="fas fa-images"></i>
                  <span>Banners del inicio</span>
                </router-link>

                <router-link
                  to="/configuracion/notificaciones"
                  class="nav-link"
                  :class="{
                    active: $route.path === '/configuracion/notificaciones',
                  }"
                  @click="isMobileMenuOpen && toggleMobileMenu()"
                >
                  <i class="fas fa-bell"></i>
                  <span>Notificaciones</span>
                  <span
                    v-if="notificationsUnreadCount > 0"
                    class="notification-dot"
                    :aria-label="`${notificationsUnreadCount} notificaciones sin leer`"
                  >
                    {{ notificationsUnreadCount > 9 ? '9+' : notificationsUnreadCount }}
                  </span>
                </router-link>

                <!-- Submenu: Ventas y Actividad -->
                <div class="submenu-container">
                  <button
                    class="submenu-toggle"
                    :class="{
                      active:
                        openSubmenus.ventas ||
                        $route.path.includes('/configuracion/ventas') ||
                        $route.path.includes('/configuracion/actividad') ||
                        $route.path.includes('/configuracion/new-sale'),
                    }"
                    @click="toggleSubmenu('ventas')"
                  >
                    <div>
                      <i class="fas fa-shopping-cart menu-icon"></i>
                      <span>Ventas</span>
                    </div>
                    <i class="fas fa-chevron-down toggle-icon"></i>
                  </button>
                  <div
                    class="submenu"
                    :class="{
                      open:
                        openSubmenus.ventas ||
                        $route.path.includes('/configuracion/ventas') ||
                        $route.path.includes('/configuracion/actividad') ||
                        $route.path.includes('/configuracion/new-sale')
                    }"
                  >                    <router-link
                      to="/configuracion/ventas"
                      class="nav-link"
                      :class="{
                        active: $route.path === '/configuracion/ventas',
                      }"
                      @click="isMobileMenuOpen && toggleMobileMenu()"
                    >
                      <i class="fas fa-clipboard-list"></i>
                      <span>Lista de Ventas</span>
                    </router-link>
                    <router-link
                      to="/configuracion/stats"
                      class="nav-link"
                      :class="{
                        active: $route.path === '/configuracion/stats',
                      }"
                      @click="isMobileMenuOpen && toggleMobileMenu()"
                    >
                      <i class="fas fa-chart-pie"></i>
                      <span>Métricas</span>
                    </router-link>
                    <router-link
                      to="/configuracion/ventas/nueva"
                      class="nav-link"
                      :class="{
                        active: $route.path === '/configuracion/ventas/nueva',
                      }"
                      @click="isMobileMenuOpen && toggleMobileMenu()"
                    >
                      <i class="fas fa-plus"></i>
                      <span>Nueva Venta</span>
                    </router-link>
                  </div>
                </div>                <!-- Submenu: Usuarios (Clientes + Equipo unificados) -->
                <div class="submenu-container">
                  <button
                    class="submenu-toggle"
                    :class="{
                      active:
                        openSubmenus.usuarios ||
                        activeSection === 'customers' ||
                        $route.path.includes('/configuracion/clientes') ||
                        $route.path.includes('/configuracion/distribuidores-pendientes') ||
                        $route.path.includes('/configuracion/roles')
                    }"
                    @click="toggleSubmenu('usuarios')"
                  >
                    <div>
                      <i class="fas fa-users menu-icon"></i>
                      <span>Usuarios</span>
                    </div>
                    <i class="fas fa-chevron-down toggle-icon"></i>
                  </button>
                  <div
                    class="submenu"
                    :class="{
                      open:
                        openSubmenus.usuarios ||
                        activeSection === 'customers' ||
                        $route.path.includes('/configuracion/clientes') ||
                        $route.path.includes('/configuracion/distribuidores-pendientes') ||
                        $route.path.includes('/configuracion/roles')
                    }"
                  >
                    <router-link
                      to="/configuracion/clientes"
                      class="nav-link"
                      :class="{
                        active: $route.path === '/configuracion/clientes'
                      }"
                      @click="isMobileMenuOpen && toggleMobileMenu()"
                    >
                      <i class="fas fa-list"></i>
                      <span>Lista de Usuarios</span>
                    </router-link>

                    <router-link
                      to="/configuracion/clientes/crear"
                      class="nav-link"
                      :class="{
                        active: $route.path === '/configuracion/clientes/crear'
                      }"
                      @click="isMobileMenuOpen && toggleMobileMenu()"
                    >
                      <i class="fas fa-user-plus"></i>
                      <span>Crear Cliente</span>
                    </router-link>

              

                    <router-link
                      to="/configuracion/roles"
                      class="nav-link"
                      :class="{
                        active: $route.path === '/configuracion/roles',
                      }"
                      @click="isMobileMenuOpen && toggleMobileMenu()"
                    >
                      <i class="fas fa-user-tag"></i>
                      <span>Roles y Permisos</span>
                    </router-link>
                  </div>
                </div>
                <!-- Submenu: Productos y Categorías -->
                <div class="submenu-container">
                  <button
                    class="submenu-toggle"
                    :class="{
                      active:
                        openSubmenus.productos ||
                        $route.path.includes('/configuracion/productos') ||
                        $route.path.includes('/configuracion/categorias') ||
                        $route.path.includes('/configuracion/resenas'),
                    }"
                    @click="toggleSubmenu('productos')"
                  >
                    <div>
                      <i class="fas fa-box menu-icon"></i>
                      <span>Productos</span>
                    </div>
                    <i class="fas fa-chevron-down toggle-icon"></i>
                  </button>
                  <div
                    class="submenu"
                    :class="{
                      open:
                        openSubmenus.productos ||
                        $route.path.includes('/configuracion/productos') ||
                        $route.path.includes('/configuracion/categorias') ||
                        $route.path.includes('/configuracion/resenas'),
                    }"
                  >
                    <router-link
                      to="/configuracion/productos"
                      class="nav-link"
                      :class="{
                        active: $route.path === '/configuracion/productos',
                      }"
                      @click="isMobileMenuOpen && toggleMobileMenu()"
                    >
                      <i class="fas fa-list"></i>
                      <span>Lista de Productos</span>
                    </router-link>                    <router-link
                      to="/configuracion/productos/agregar"
                      class="nav-link"
                      :class="{
                        active:
                          $route.path === '/configuracion/productos/agregar',
                      }"
                      @click="isMobileMenuOpen && toggleMobileMenu()"
                    >
                      <i class="fas fa-plus"></i>
                      <span>Agregar producto</span>
                    </router-link>                    <router-link
                      to="/configuracion/categorias"
                      class="nav-link"
                      :class="{
                        active: $route.path === '/configuracion/categorias',
                      }"
                      @click="isMobileMenuOpen && toggleMobileMenu()"
                    >
                      <i class="fas fa-tags"></i>
                      <span>Categorías</span>
                    </router-link>
                  </div>
                </div>
                <!-- Submenu: Marketing -->
                <div class="submenu-container">
                  <button
                    class="submenu-toggle"
                    :class="{
                      active:
                        openSubmenus.marketing ||
                        $route.path.includes('/configuracion/coupons') ||
                        $route.path.includes('/configuracion/offers') ||
                        $route.path.includes('/configuracion/scheduled-discounts'),
                    }"
                    @click="toggleSubmenu('marketing')"
                  >
                    <div>
                      <i class="fas fa-bullhorn menu-icon"></i>
                      <span>Marketing</span>
                    </div>
                    <i class="fas fa-chevron-down toggle-icon"></i>
                  </button>
                  <div
                    class="submenu"
                    :class="{
                      open:
                        openSubmenus.marketing ||
                        $route.path.includes('/configuracion/coupons') ||
                        $route.path.includes('/configuracion/offers') ||
                        $route.path.includes('/configuracion/scheduled-discounts'),
                    }"
                  >
                    <router-link
                      to="/configuracion/coupons"
                      class="nav-link"
                      :class="{
                        active: $route.path === '/configuracion/coupons',
                      }"
                      @click="isMobileMenuOpen && toggleMobileMenu()"
                    >
                      <i class="fas fa-ticket-alt"></i>
                      <span>Cupones</span>
                    </router-link>

                    <router-link
                      to="/configuracion/offers"
                      class="nav-link"
                      :class="{
                        active: $route.path === '/configuracion/offers',
                      }"
                      @click="isMobileMenuOpen && toggleMobileMenu()"
                    >
                      <i class="fas fa-tags"></i>
                      <span>Ofertas</span>
                    </router-link>
                  </div>
                </div>

                <!-- Submenu: Envíos -->
                <div class="submenu-container">
                  <button
                    class="submenu-toggle"
                    :class="{
                      active:
                        openSubmenus.envios ||
                        $route.path.includes('/configuracion/envios'),
                    }"
                    @click="toggleSubmenu('envios')"
                  >
                    <div>
                      <i class="fas fa-truck menu-icon"></i>
                      <span>Envíos</span>
                    </div>
                    <i class="fas fa-chevron-down toggle-icon"></i>
                  </button>
                  <div
                    class="submenu"
                    :class="{
                      open:
                        openSubmenus.envios ||
                        $route.path.includes('/configuracion/envios'),
                    }"
                  >
                    <router-link
                      to="/configuracion/envios"
                      class="nav-link"
                      :class="{
                        active: $route.path === '/configuracion/envios',
                      }"
                      @click="isMobileMenuOpen && toggleMobileMenu()"
                    >
                      <i class="fas fa-shipping-fast"></i>
                      <span>Gestión de Envíos</span>
                    </router-link>
                    <router-link
                      to="/configuracion/envios/config"
                      class="nav-link"
                      :class="{
                        active: $route.path === '/configuracion/envios/config',
                      }"
                      @click="isMobileMenuOpen && toggleMobileMenu()"
                    >
                      <i class="fas fa-cog"></i>
                      <span>Configuración</span>
                    </router-link>
                  </div>
                </div>

              </div>
              <!-- User Menu -->
              <div class="nav-section">
                <h6 class="nav-title">PERFIL</h6>

                <div class="submenu-container">
                  <button
                    class="submenu-toggle"
                    :class="{
                      active:
                        openSubmenus.account ||
                        activeSection === 'settings' ||
                        $route.path === '/configuracion/my-orders',
                    }"
                    @click="toggleSubmenu('account')"
                  >
                    <div>
                      <i class="fas fa-user menu-icon"></i>
                      <span>Configuración</span>
                    </div>
                    <i class="fas fa-chevron-down toggle-icon"></i>
                  </button>
                  <div
                    class="submenu"
                    :class="{
                      open:
                        openSubmenus.account ||
                        activeSection === 'settings' ||
                        $route.path === '/configuracion/my-orders',
                    }"
                  >
                    <router-link
                      to="/configuracion/my-orders"
                      class="nav-link"
                      :class="{
                        active: $route.path === '/configuracion/my-orders',
                      }"
                      @click="isMobileMenuOpen && toggleMobileMenu()"
                    >
                      <i class="fas fa-shopping-bag"></i>
                      <span>Mis Pedidos</span>
                    </router-link>
                    <router-link
                      to="/configuracion/mi-cuenta"
                      class="nav-link"
                      :class="{
                        active: $route.path === '/configuracion/mi-cuenta',
                      }"
                      @click="isMobileMenuOpen && toggleMobileMenu()"
                    >
                      <i class="fas fa-user-cog"></i>
                      <span>Mi Cuenta</span>
                    </router-link>
                    <router-link
                      to="/configuracion/direcciones"
                      class="nav-link"
                      :class="{
                        active: $route.path === '/configuracion/direcciones',
                      }"
                      @click="isMobileMenuOpen && toggleMobileMenu()"
                    >
                      <i class="fas fa-map-marker-alt"></i>
                      <span>Direcciones</span>
                    </router-link>
                    <router-link
                      to="/configuracion/mi-tienda"
                      class="nav-link"
                      :class="{
                        active: $route.path === '/configuracion/mi-tienda',
                      }"
                      @click="isMobileMenuOpen && toggleMobileMenu()"
                      v-if="isAdmin"
                    >
                      <i class="fas fa-cog"></i>
                      <span>General</span>
                    </router-link>
                  </div>
                </div>
              </div>
            </nav>

            <!-- Logout Button -->
            <button @click="handleLogout" class="logout-btn fs-6 mt-5">
              <i class="fas fa-sign-out-alt"></i>
              <span>Cerrar Sesión</span>
            </button>
          </div>
        </aside>

        <!-- Backdrop for mobile menu -->
        <div
          class="mobile-backdrop d-lg-none"
          :class="{ active: isMobileMenuOpen }"
          @click="toggleMobileMenu"
        ></div>

        <main class="col-lg-10 main-content" style="min-width: 0;">
          <!-- Mobile Header -->
          <div class="mobile-header d-lg-none mx-2">
            <button 
              class="btn btn-icon menu-toggle"
              @click="toggleMobileMenu"
            >
              <i class="fas fa-bars"></i>
            </button>
            <h1 class="header-title mb-0">{{ getSectionTitle() }}</h1>
            <div class="header-actions">
              <!-- Placeholder para futuros botones de acción -->
            </div>
          </div>          <!-- Router View for nested routes -->
          <router-view 
            v-if="$route.path !== '/configuracion'" 
            class="router-view-container"
            :key="$route.fullPath"
          >
            <template #default="{ Component }">
              <transition name="fade" mode="out-in">
                <component :is="Component" />
              </transition>
            </template>
          </router-view>

          <!-- Default content when on base configuration route -->
          <div v-else class="content-section pt-lg-0">
            <!-- Overview Section -->
            <div
              v-if="activeSection === 'overview'"
              class="content-section ps-lg-0 pt-lg-0 px-1"
            >
              <AdminOverview />
            </div>

            <!-- Settings Section -->
            <div
              v-if="activeSection === 'settings'"
              class="content-section ps-lg-0"
            >
              <UserSettings />
            </div>

            <!-- Customers Section -->
            <div
              v-if="activeSection === 'customers'"
              class="content-section ps-lg-0"
            >
              <h2 class="section-title">Gestión de Clientes</h2>
              <AdminCustomersList />
            </div>

            <!-- Messages Section -->
            <div
              v-if="activeSection === 'messages'"
              class="content-section ps-lg-0"
            >
              <h2 class="section-title">Mensajes de Clientes</h2>
              <AdminMessagesList />
            </div>

            <!-- Coupons Section -->
            <div
              v-if="activeSection === 'coupons'"
              class="content-section ps-lg-0"
            >
              <h2 class="section-title">Gestión de Cupones</h2>
              <AdminCoupons />
            </div>
            <!-- Orders Section -->
            <div
              v-if="activeSection === 'orders'"
              class="content-section ps-lg-0"
            >
              <CustomerOrders />
            </div>

            <!-- Offers Section -->
            <div
              v-if="activeSection === 'offers'"
              class="content-section ps-lg-0"
            >
              <h2 class="section-title">Gestión de Ofertas</h2>
              <AdminOffers />
            </div>
            <!-- Stats Section - Nueva sección para estadísticas -->
            <div
              v-if="activeSection === 'stats'"
              class="content-section ps-lg-0"
            >
              <AdminStats />
            </div>
            <!-- Reviews Section - Nueva sección para reseñas -->
            <div
              v-if="activeSection === 'resenas'"
              class="content-section ps-lg-0"
            >
              <AdminReviews />
            </div>
          </div>
        </main>
      </div>
    </div>

    <!-- Password Verification Modal is handled in UserSettings component -->
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
import AdminCustomersList from "@/pages/admin/AdminCustomersList.vue";
import AdminMessagesList from "@/pages/admin/components/AdminMessagesList.vue";
import AdminOverview from "@/pages/admin/AdminOverview.vue";
import AdminCoupons from "@/pages/admin/AdminCoupons.vue";
import UserSettings from "@/components/settings/UserSettings.vue";
import CustomerOrders from "@/components/customer/CustomerOrders.vue";
import AdminOffers from "@/pages/admin/AdminOffers.vue";
import AdminStats from "@/pages/admin/AdminStats.vue";
import AdminReviews from "@/pages/admin/AdminReviews.vue";
import { useToast } from "vue-toastification";
import { checkAdminStatus } from "@/services/apiClient";
import { getLowStockNotifications, getPendingReviews } from "@/services/products";
import {
  LOW_STOCK_READ_EVENT,
  countUnreadLowStockNotifications,
} from "@/utils/notificationReadState";
import '@/assets/styles/admin-components.css';

const router = useRouter();
const route = useRoute();
const isAdmin = ref(false);
const activeSection = ref(null);
const isMobileMenuOpen = ref(false);
const pendingReviewsCount = ref(0);
const notificationsUnreadCount = ref(0);
const openSubmenus = ref({
  productos: false,
  ventas: false,
  usuarios: false,
  marketing: false,
  envios: false,
  account: false,
  diseno: false,
});
const toast = useToast();

// Función para obtener el título de la sección actual
const getSectionTitle = () => {
  switch (activeSection.value) {
    case 'overview':
      return 'Panel General';
    case 'ventas':
      return 'Ventas';
    case 'customers':
      return 'Clientes';
    case 'productos':
      return 'Productos';
    case 'coupons':
      return 'Cupones';
    case 'offers':
      return 'Ofertas';
    case 'settings':
      return 'Configuración';
    case 'orders':
      return 'Mis Pedidos';
    case 'stats':
      return 'Estadísticas'; 
    case 'resenas':
      return 'Reseñas';
    case 'envios':
      return 'Envíos';
    case 'notificaciones':
      return 'Notificaciones';
    case 'hero-banners':
      return 'Banners del inicio';
    default:
      return 'Panel de Control';
  }
};

// Función para inicializar el estado basado en la ruta actual
const initializeFromRoute = (path) => {
  console.log('Initializing from route:', path);
  
  // Resetear todos los submenús
  Object.keys(openSubmenus.value).forEach(key => {
    openSubmenus.value[key] = false;
  });

  // Determinar la sección activa y el submenú a abrir
  if (path.includes('/configuracion/ventas') || path.includes('/configuracion/stats')) {
    if (path.includes('/configuracion/stats')) {
      activeSection.value = 'stats';
    } else {
      activeSection.value = 'ventas';
    }
    openSubmenus.value.ventas = true;
  } else if (path.includes('/configuracion/productos') || path.includes('/configuracion/categorias') || path.includes('/configuracion/resenas')) {
    if (path.includes('/configuracion/resenas')) {
      activeSection.value = 'resenas';
    } else {
      activeSection.value = 'productos';
    }
    openSubmenus.value.productos = true;
  } else if (path.includes('/configuracion/clientes') || path.includes('/configuracion/distribuidores-pendientes') || path.includes('/configuracion/roles')) {
    activeSection.value = 'customers';
    openSubmenus.value.usuarios = true;
  } else if (path.includes('/configuracion/notificaciones')) {
    activeSection.value = 'notificaciones';
  } else if (path.includes('/configuracion/banners-inicio')) {
    activeSection.value = 'hero-banners';
  } else if (path.includes('/configuracion/coupons') || path.includes('/configuracion/offers') || path.includes('/configuracion/scheduled-discounts')) {
    if (path.includes('/configuracion/coupons')) {
      activeSection.value = 'coupons';
    } else if (path.includes('/configuracion/scheduled-discounts')) {
      activeSection.value = 'scheduled-discounts';
    } else {
      activeSection.value = 'offers';
    }
    openSubmenus.value.marketing = true;
  } else if (path.includes('/configuracion/envios')) {
    activeSection.value = 'envios';
    openSubmenus.value.envios = true;
  } else if (path.includes('/configuracion/my-orders')) {
    activeSection.value = 'orders';
    openSubmenus.value.account = true;
  } else if (path.includes('/configuracion/mi-cuenta') || path.includes('/configuracion/mi-tienda') || path.includes('/configuracion/direcciones')) {
    activeSection.value = 'settings';
    openSubmenus.value.account = true;
  } else if (path === '/configuracion') {
    activeSection.value = 'overview';
  } else {
    activeSection.value = null;
  }

  console.log('Active section set to:', activeSection.value);
  console.log('Open submenus:', JSON.stringify(openSubmenus.value));
};

// Función para verificar si el usuario es administrador a través del servidor
const verifyAdminStatus = async () => {
  try {
    // Verificar con el servidor el estado real del usuario
    const adminStatus = await checkAdminStatus(true);
    isAdmin.value = adminStatus;
    
    // Si el usuario no es admin pero está en una ruta de admin, redirigirlo
    if (!isAdmin.value && (
      route.path.includes('/configuracion/admin') || 
      route.path.includes('/configuracion/productos') || 
      route.path.includes('/configuracion/ventas') || 
      route.path.includes('/configuracion/categorias') ||
      route.path.includes('/configuracion/stats') ||
      route.path.includes('/configuracion/coupons') ||
      route.path.includes('/configuracion/offers') ||
      route.path.includes('/configuracion/notificaciones') ||
      route.path.includes('/configuracion/banners-inicio') ||
      route.path.includes('/configuracion/mi-tienda')
    )) {
      router.push('/configuracion/my-orders');
    }
  } catch (error) {
    console.error('Error verificando estado de administrador:', error);
    toast.error('Error verificando permisos de administrador');
    router.push('/configuracion/my-orders');
  }
};

// Cargar el número de reseñas pendientes
const loadPendingReviewsCount = async () => {
  try {
    if (isAdmin.value) {
      const pendingReviews = await getPendingReviews();
      pendingReviewsCount.value = Array.isArray(pendingReviews) ? pendingReviews.length : 0;
    }
  } catch (error) {
    console.error('Error al cargar reseñas pendientes:', error);
  }
};

// Redirigir al usuario según su rol cuando se monta el componente
const loadNotificationsUnreadCount = async () => {
  try {
    if (!isAdmin.value) {
      notificationsUnreadCount.value = 0;
      return;
    }
    const data = await getLowStockNotifications({ threshold: 10 });
    const items = Array.isArray(data.items) ? data.items : [];
    notificationsUnreadCount.value = countUnreadLowStockNotifications(items);
  } catch (error) {
    console.error('Error al cargar notificaciones pendientes:', error);
  }
};

onMounted(async () => {
  document.addEventListener('click', handleClickOutside);
  
  // Verificar estado de administrador
  await verifyAdminStatus();
  
  // Cargar reseñas pendientes
  await loadPendingReviewsCount();
  await loadNotificationsUnreadCount();
  
  // Inicializar estado basado en la ruta actual
  initializeFromRoute(route.path);
  
  // Configurar intervalo para actualizar el contador de reseñas pendientes
  const interval = setInterval(async () => {
    await loadPendingReviewsCount();
    await loadNotificationsUnreadCount();
  }, 60000); // Actualizar cada minuto

  window.addEventListener(LOW_STOCK_READ_EVENT, loadNotificationsUnreadCount);
  window.addEventListener('storage', loadNotificationsUnreadCount);
  
  // Limpiar intervalo al desmontar
  onUnmounted(() => {
    clearInterval(interval);
    window.removeEventListener(LOW_STOCK_READ_EVENT, loadNotificationsUnreadCount);
    window.removeEventListener('storage', loadNotificationsUnreadCount);
  });
});



// Watch para detectar cambios de ruta
watch(
  () => route.path,
  async (newPath, oldPath) => {
    // Solo procesar si la ruta realmente cambió
    if (newPath === oldPath) return;
    
    console.log('Route changed from:', oldPath, 'to:', newPath);
    
    // Cerrar menú móvil si está abierto
    if (isMobileMenuOpen.value) {
      isMobileMenuOpen.value = false;
      document.body.style.overflow = '';
    }
    
    // Verificar estado de administrador al cambiar de ruta
    await verifyAdminStatus();
    
    // Actualizar contador de reseñas pendientes si es administrador
    if (isAdmin.value) {
      await loadPendingReviewsCount();
      await loadNotificationsUnreadCount();
    }
    
    // Verificar permisos de acceso según la ruta
    if (!isAdmin.value && (
      newPath.includes('/configuracion/admin') || 
      newPath.includes('/configuracion/productos') || 
      newPath.includes('/configuracion/ventas') || 
      newPath.includes('/configuracion/categorias') ||
      newPath.includes('/configuracion/stats') ||
      newPath.includes('/configuracion/coupons') ||
      newPath.includes('/configuracion/offers') ||
      newPath.includes('/configuracion/notificaciones') ||
      newPath.includes('/configuracion/banners-inicio') ||
      newPath.includes('/configuracion/mi-tienda') ||
      newPath.includes('/configuracion/reviews')
    )) {
      router.push('/configuracion/my-orders');
      return;
    }
    
    // Inicializar estado basado en la nueva ruta
    nextTick(() => {
      initializeFromRoute(newPath);
    });
  },
  { immediate: false }
);

const handleLogout = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("isAdmin");
  localStorage.removeItem("cart");
  localStorage.removeItem("userOrders");
  localStorage.removeItem("adminOrders");
  window.location.reload();
};

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
  
  // Prevenir scroll cuando el menú está abierto
  document.body.style.overflow = isMobileMenuOpen.value ? 'hidden' : '';
};

// Modificar toggleSubmenu para asegurar que solo un submenú está abierto
const toggleSubmenu = async (submenu) => {
  // Si el submenú ya está abierto, cerrarlo
  if (openSubmenus.value[submenu]) {
    openSubmenus.value[submenu] = false;
    return;
  }
  
  // Cerrar todos los demás submenús
  Object.keys(openSubmenus.value).forEach(key => {
    openSubmenus.value[key] = false;
  });
  
  // Verificar estado de administrador antes de permitir acceso a submenús protegidos
  if (submenu === 'mi-tienda' || submenu === 'diseno' || submenu === 'ventas' || 
      submenu === 'productos' || submenu === 'clientes' || submenu === 'marketing') {
    try {
      const adminStatus = await checkAdminStatus(true);
      isAdmin.value = adminStatus;
      
      if (!isAdmin.value) {
        return;
      }
    } catch (error) {
      toast.error('Error verificando permisos de administrador');
      return;
    }
  }
  
  // Abrir el submenú seleccionado
  openSubmenus.value[submenu] = true;
};

// Cerrar submenús cuando se hace click fuera
const handleClickOutside = (event) => {
  const isClickInside = event.target.closest('.submenu-container');
  if (!isClickInside) {
    Object.keys(openSubmenus.value).forEach(key => {
      openSubmenus.value[key] = false;
    });
  }
};

onUnmounted(() => {
  document.body.style.overflow = '';
  document.removeEventListener('click', handleClickOutside);
});

</script>
<style scoped>
@import "@/assets/styles/account-settings.css";
@import "@/assets/styles/sidebar-submenu.css";
@import "@/assets/styles/admin-components.css";

.main-content {
  --admin-sticky-offset: 0px;
}

/* Submenu overrides */
.submenu {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.25s ease, opacity 0.15s ease;
  opacity: 0;
}

.submenu.open {
  max-height: 500px;
  opacity: 1;
}

.submenu-toggle {
  width: 100%;
  text-align: left;
  padding: 0.55rem 0.75rem;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  color: #aaa;
  font-size: 0.84rem;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.15s ease;
}

.submenu-toggle:hover {
  background: rgba(255,255,255,0.06);
  color: #fff;
}

.submenu-toggle .toggle-icon {
  font-size: 0.62rem;
  color: #555;
  transition: transform 0.2s ease;
}

.submenu-toggle.active .toggle-icon {
  transform: rotate(-180deg);
  color: #888;
}

.submenu-toggle.active {
  color: #fff;
}

/* Nav link overrides */
.nav-link {
  padding: 0.55rem 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #aaa;
  text-decoration: none;
  font-size: 0.84rem;
  font-weight: 500;
  border-radius: 8px;
  background: transparent;
  transition: all 0.15s ease;
  margin-bottom: 1px;
}

.nav-link:hover {
  background: transparent;
  color: #fff;
}

.nav-link.active,
.nav-link.router-link-exact-active {
  background: rgba(239, 68, 68, 0.12);
  color: #f87171;
}

.nav-link i {
  width: 18px;
  text-align: center;
  font-size: 0.82rem;
  flex-shrink: 0;
}

.notification-dot {
  margin-left: auto;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--primary-color, #ef4444);
  color: #fff;
  font-size: 0.62rem;
  font-weight: 800;
  line-height: 1;
  box-shadow: 0 0 0 2px var(--black-color-2, #141414);
}

/* Mobile header: sticky arriba; el formulario de producto usa --admin-sticky-offset para su propia barra */
@media (max-width: 991.98px) {
  .main-content {
    --admin-sticky-offset: max(3.75rem, calc(env(safe-area-inset-top, 0px) + 3.1rem));
  }

  .mobile-header {
    position: sticky;
    top: 0;
    z-index: 1030;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: calc(0.65rem + env(safe-area-inset-top, 0px)) 0.5rem 0.65rem;
    margin: -0.25rem -0.5rem 0;
    padding-left: max(0.5rem, env(safe-area-inset-left, 0px));
    padding-right: max(0.5rem, env(safe-area-inset-right, 0px));
    background: var(--black-color-2, #141414);
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  }
}

.mobile-header .btn-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(255,255,255,0.06);
  border: none;
  color: #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.mobile-header .btn-icon:hover {
  background: rgba(255,255,255,0.12);
  color: #fff;
}

.header-title {
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
}

/* Router view container — sin overflow oculto para que sticky del contenido (p. ej. ProductForm) funcione */
.router-view-container {
  display: block;
  overflow: visible;
  min-width: 0;
  animation: fadeIn 0.15s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Mobile backdrop */
.mobile-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);
  z-index: 1040;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.25s ease;
}

.mobile-backdrop.active {
  opacity: 1;
  pointer-events: all;
}

/* Badge */
.badge {
  font-size: 0.66rem;
  font-weight: 600;
  padding: 0.2rem 0.45rem;
  border-radius: 5px;
}

/* Section title */
.section-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #fff;
}
</style>
